<template>
    <div class="h-screen flex flex-col overflow-hidden bg-capBg">
        <div class="flex flex-1 overflow-hidden">
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog as="div" static class="fixed inset-0 flex z-40 md:hidden" @close="sidebarOpen = false"
                :open="sidebarOpen">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300"
                    enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300"
                    leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
                </TransitionChild>
                <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                    enter-from="-translate-x-full" enter-to="translate-x-0"
                    leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                    leave-to="-translate-x-full">
                    <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-capPurple">
                        <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                            enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100"
                            leave-to="opacity-0">
                            <div class="absolute top-0 right-0 -mr-12 pt-2">
                                <button type="button"
                                    class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                    @click="sidebarOpen = false">
                                    <span class="sr-only">Close sidebar</span>
                                    <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
                                </button>
                            </div>
                        </TransitionChild>
                        <div class="flex items-center flex-shrink-0 px-4">
                            <span class="text-gray-100 text-md">Hello</span>
                        </div>
                        <div class="flex items-center flex-shrink-0 px-4 mb-5">
                            <span class="text-gray-100 text-2xl pl-5 font-semibold">{{ store.state.user.firstName
                                }}</span>
                        </div>
                        <div class="mt-5 flex-1 h-0 overflow-y-auto">
                            <nav class="px-2 space-y-1">
                                <router-link v-for="item in navigation" :key="item.name" :to="item.to"
                                    :class="[$route.meta?.module == item.module ? 'bg-indigo-800 text-white font-semibold' : 'text-indigo-100 hover:bg-capLightPurple ', 'group flex items-center px-2 py-2 text-base font-medium rounded-md']">
                                    <component :is="item.icon" class="mr-4 flex-shrink-0 h-6 w-6 text-indigo-300"
                                        aria-hidden="true" />
                                    {{ item.name }}
                                </router-link>
                                <div class="text-white hover:bg-capLightPurple group flex items-center px-2 py-2">
                                    <DocumentDuplicateIcon class="mr-4 flex-shrink-0 h-6 w-6 text-indigo-300" />
                                    <a :href="TERMS_AND_CONDITIONS_URL"
                                        class="text-indigo-100 text-base font-medium">
                                        Terms &amp; Conditions
                                    </a>
                                </div>
                                <div class="text-white hover:bg-capLightPurple group flex items-center px-2 py-2">
                                    <BookOpenIcon class="mr-4 flex-shrink-0 h-6 w-6 text-indigo-300" />
                                    <a :href="PLAN_COMPARISON_URL"
                                        class="text-indigo-100 text-base font-medium">
                                        Plan Comparison
                                    </a>
                                </div>
                                <div
                                    class="text-white hover:bg-capLightPurple group flex items-center px-2 py-2 cursor-pointer"
                                    role="button"
                                    tabindex="0"
                                    @click="showHowToRead = true"
                                    @keydown.enter="showHowToRead = true"
                                    @keydown.space.prevent="showHowToRead = true"
                                >
                                    <DocumentSearchIcon class="mr-4 flex-shrink-0 h-6 w-6 text-indigo-300" />
                                    <span class="text-indigo-100 text-base font-medium">
                                        How to read your agreement
                                    </span>
                                </div>
                            </nav>
                        </div>
                    </div>
                </TransitionChild>
                <div class="flex-shrink-0 w-14" aria-hidden="true">
                    <!-- Dummy element to force sidebar to shrink to fit close icon -->
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Static sidebar for desktop -->
        <div class="hidden bg-capPurple md:flex md:flex-shrink-0">
            <div class="flex flex-col w-48">
                <!-- Sidebar component, swap this element with another sidebar if you like -->
                <div class="flex flex-col flex-grow pt-5 pb-4 overflow-y-auto">
                    <div class="flex items-center flex-shrink-0 px-4">
                        <span class="text-gray-100 text-lg">Hello</span>
                    </div>
                    <div class="flex items-center flex-shrink-0 px-4 mb-5">
                        <span class="text-gray-100 text-3xl pl-5 font-semibold">{{ store.state.user.firstName }}</span>
                    </div>
                    <div class="mt-5 flex-1 flex flex-col">
                        <nav class="flex-1 px-2 space-y-1">
                            <router-link v-for="item in navigation" :key="item.name" :to="item.to"
                                :class="[$route.meta?.module == item.module ? 'bg-gray-100 bg-opacity-25 text-white font-semibold' : 'text-white hover:bg-capLightPurple', 'group flex items-center px-2 py-2']">
                                <component :is="item.icon" class="mr-3 flex-shrink-0 h-6 w-6 text-white"
                                    aria-hidden="true" />
                                {{ item.name }}
                            </router-link>
                            <div class="text-white hover:bg-capLightPurple group flex items-center px-2 py-2">
                                <DocumentDuplicateIcon class="mr-3 flex-shrink-0 h-6 w-6 text-white" />
                                <a :href="TERMS_AND_CONDITIONS_URL"
                                    class="text-white">
                                    Terms &amp; Conditions
                                </a>
                            </div>
                            <div class="text-white hover:bg-capLightPurple group flex items-center px-2 py-2">
                                <BookOpenIcon class="mr-3 flex-shrink-0 h-6 w-6 text-white" />
                                <a :href="PLAN_COMPARISON_URL"
                                    class="text-white">
                                    Plan Comparison
                                </a>
                            </div>
                            <div
                                class="text-white hover:bg-capLightPurple group flex items-center px-2 py-2 cursor-pointer"
                                role="button"
                                tabindex="0"
                                @click="showHowToRead = true"
                                @keydown.enter="showHowToRead = true"
                                @keydown.space.prevent="showHowToRead = true"
                            >
                                <DocumentSearchIcon class="mr-3 flex-shrink-0 h-6 w-6 text-white" />
                                <span class="text-white">
                                    How to read your agreement
                                </span>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <c-dialog v-model="showHowToRead" title="How to Read Your Agreement" width="auto">
            <img
                :src="sampleAgreement"
                alt="Sample agreement showing how to read your agreement"
                class="max-w-full h-auto w-auto mx-auto block"
                style="max-height: 80vh"
            />
        </c-dialog>
        <div class="flex flex-col w-0 flex-1 overflow-hidden">
            <div class="relative z-10 flex-shrink-0 flex h-20 bg-white shadow">
                <button type="button"
                    class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
                    @click="sidebarOpen = true">
                    <span class="sr-only">Open sidebar</span>
                    <MenuAlt2Icon class="h-6 w-6" aria-hidden="true" />
                </button>


                <div class="flex-1 px-4 flex justify-between z-0">
                    <div class="flex-1 flex">
                        <div class="h-full flex items-center gap-4 my-auto md:px-4">
                            <a class="my-auto" href="https://www.completehomewarranty.com/">
                                <img class="h-18 w-auto left-0 my-auto" src="@/assets/cap-logo.png"
                                    alt="Complete Appliance Protection" />
                            </a>
                            <div class="hidden md:block leading-tight">
                                <a href="tel:+18009782022" class="block text-capGrey text-xs hover:text-capPurple">800-978-2022</a>
                                <a href="mailto:info@completehomewarranty.com" class="block text-capGrey text-xs hover:text-capPurple break-words">info@<wbr>completehomewarranty<wbr>.com</a>
                            </div>
                        </div>
                    </div>
                    <div class="ml-4 flex items-center md:ml-6 space-x-2 text-capPurple">
                        <p class="cursor-pointer hover:text-capLightPurple " @click="this.goToProfile()">My Profile</p>
                        <p>|</p>
                        <p class="cursor-pointer hover:text-capLightPurple" @click="this.logout()">Log Out</p>
                    </div>
                </div>
            </div>
            <div class="relative z-0 md:h-1 bg-capPurple"></div>

            <main class="flex-1 relative overflow-y-auto focus:outline-none">
                <div class="py-6 h-full">
                    <div class="px-4 sm:px-6 h-full">
                        <!-- Replace with your content -->
                        <div class="py-4 h-full">
                            <slot></slot>
                        </div>
                        <!-- /End replace -->
                    </div>
                </div>
            </main>
        </div>
        </div>
        <footer class="flex-shrink-0 md:hidden bg-white border-t border-gray-200 py-1.5">
            <div class="flex items-center justify-center gap-6">
                <a href="tel:+18009782022" class="text-capGrey text-xs hover:text-capPurple">800-978-2022</a>
                <a href="mailto:info@completehomewarranty.com" class="text-capGrey text-xs hover:text-capPurple break-words">info@<wbr>completehomewarranty<wbr>.com</a>
            </div>
        </footer>
    </div>
</template>

<script>
    import { defineComponent, ref } from 'vue'
    import {
        Dialog,
        DialogOverlay,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        TransitionChild,
        TransitionRoot,
    } from '@headlessui/vue'
    import {
        BellIcon,
        BookOpenIcon,
        DocumentDuplicateIcon,
        MenuAlt2Icon,
        DocumentSearchIcon,
        XIcon,
    } from '@heroicons/vue/outline'

    import { SearchIcon } from '@heroicons/vue/solid'
    import { useStore } from 'vuex'
    import { router } from '@/router/index.ts'
    import { PLAN_COMPARISON_URL, TERMS_AND_CONDITIONS_URL } from '@/constants/links'
    import CDialog from '@/components/ui/CDialog.vue'
    import sampleAgreement from '@/assets/Sample-Agmt.jpg'

    export default defineComponent({
        name: 'ApplicationShellVerticalExample',
        components: {
            Dialog,
            DialogOverlay,
            Menu,
            MenuButton,
            MenuItem,
            MenuItems,
            TransitionChild,
            TransitionRoot,
            BellIcon,
            BookOpenIcon,
            DocumentDuplicateIcon,
            MenuAlt2Icon,
            DocumentSearchIcon,
            SearchIcon,
            XIcon,
            CDialog,
        },
        setup() {
            const store = useStore()
            const sidebarOpen = ref(false)
            const showHowToRead = ref(false)
            const currentPage = store.state.currentPage
            const currentPageParams = store.state.currentPageParams

            //Load file path of all modules named Nav.vue
            const context = require.context('@/modules', true, /Nav.ts$/i)

            //Import each component
            const modules = context.keys()
                .map(context)
                .map(m => m.nav)

            //Sort them based on the position data prop

            // Filtering Licensing for Sales Force customers.
            const navigation = modules.filter(m => {
                if (store.state.user.loggedIn == "false") {
                    return m.name != "Licensing" && m.show
                } else {
                    return m.show
                }
            }).sort((a, b) => {
                let aPos = a.position
                let bPos = b.position
                if (aPos < bPos) {
                    return -1
                } else if (aPos > bPos) {
                    return 1
                } else {
                    return 0
                }
            })

            return {
                navigation,
                sidebarOpen,
                showHowToRead,
                store,
                currentPage,
                currentPageParams,
                PLAN_COMPARISON_URL,
                TERMS_AND_CONDITIONS_URL,
                sampleAgreement,
            }
        },
        methods: {
            goToProfile() {
                this.$router.push({ name: "My Profile" })
            },
            logout() {
                this.store.commit('logout');
                this.$router.push({ name: 'Login' })
            }
        },
        mounted() {
            if (this.currentPage == "") {
                router.push({ name: "Contracts" })
            } else {
                router.push({ name: this.currentPage, params: this.currentPageParams })
            }
        }
    })
</script>
